import Modal from '../../components/modal.js';

namespace('IO.Views', function (exports) {
  var ConfirmationModal = Modal.extend({
    dom: {
      CONFIRMATION_MESSAGE: '#confirmation-message',
      OK_LINK: '#ok-link',
      CANCEL_LINK: '#cancel-link',
    },

    events: function () {
      var events = {};

      events['click ' + this.dom.OK_LINK] = '_confirm';
      events['click ' + this.dom.CANCEL_LINK] = '_cancel';
      return events;
    },

    show: function (message, callback, position) {
      var self = this,
        centerPosition;

      $(this.dom.CONFIRMATION_MESSAGE).html(message);
      this.trigger('modalContentSet', this.$el);
      this.opts.callback = callback;

      centerPosition = {
        top: $(document).scrollTop() + $(window).height() / 4,
        left: ($(window).width() - this.$el.width()) / 2,
      };

      this._showBackground();
      this._setPosition(position || centerPosition);
      this.waiting(false);

      self.$el.css({ display: 'block' });
      self.$el.addClass('modal-fade-in');

      return this;
    },

    close: function () {
      this.$el.removeClass('modal-fade-in');
      this.$background.removeClass('modal-fade-in');

      this.trigger('modalClosed');
      this._afterClose();

      return this;
    },

    removeListener: function () {
      this.$el.off('click');
    },

    _afterClose: function () {
      $('.modal-background').css({ zIndex: 100 });
    },

    _cancel: function (e) {
      e.preventDefault();
      this._callback(false);
    },

    _confirm: function (e) {
      e.preventDefault();
      this._callback(true);
    },

    _callback: function (value) {
      this.close();
      this.opts.callback(value);
    },
  });

  exports.ConfirmationModal = ConfirmationModal;
});
